module.exports = __webpack_public_path__ + "static/img/1.e04ecfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p2/1.png
// module id = wDij
// module chunks = 1